import React, { Fragment } from 'react'
import store from '../store'

export default [
  {
    title: '派单号',
    dataIndex: 'order_no'
  },
  {
    title: '结算类型',
    dataIndex: 'type',
    render: (type, { return_times }) => (
      <Fragment>
        {type == '1' && '首次结算'}
        {type == '2' && `多退少补(${return_times})`}
        {type == '3' && '退单'}
      </Fragment>
    )
  },
  {
    title: '客户称呼',
    dataIndex: 'lead_name'
  },
  {
    title: '婚宴时间',
    dataIndex: 'wedding_day'
  },
  {
    title: '账单日',
    dataIndex: 'created_at',
    render: () =>
      store.detail.created_at && store.detail.created_at.substring(0, 10)
  },
  {
    title: '应付金额',
    dataIndex: 'actual_money'
  },
  {
    title: '提交时间',
    dataIndex: 'created_at'
  }
]
